import "./ForgetPass.css";
import ArrowRight from "../../assets/icons/ArrowRight.svg";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import FallbackImg from "../../components/FallbackImg";
import ApiService from "../../components/Api_services";
import { useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
const ForgetPass = () => {

  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async () => {
    setLoading(true);
    setMsg("");
    try {
      const res = await ApiService.customerForgot(email);
      if (res.status === "success") {
        navigate("/forgetpass2"); // 发送成功后跳转
      } else {
        setMsg(res.message || "Failed to send email.");
      }
    } catch (err) {
      setMsg("Error, please try again.");
    }
    setLoading(false);
  };

  return (
    <div className="forgetpass">
      <div className="forgetpass-content">
        <div>
          <Link to="/login" className="fpback-button">
            <FallbackImg src={ArrowRight} alt="arrowright" width="18" height="18" />
            <strong>Back</strong>
          </Link>
        </div>
        <div className="forgetpass-input-container">
          <div className="forgetpass-input">
            <div className="forgetpass-title">
              <strong>Forgot Password?</strong>
            </div>
            Please enter your email to continue
            <input
              type="text"
              placeholder="Email"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
            <br />
            <button onClick={handleSubmit} disabled={loading || !email}>
              {loading ? "Processing..." : "NEXT"}
            </button>
            {msg && <div style={{ marginTop: 10, color: "red" }}>{msg}</div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgetPass;
